export default {
    state:{
        non_driveLicenseShow:false,
    },
    mutations:{
        update_non_driveLicenseShow(state,{boolean=false}){
            state.non_driveLicenseShow=boolean;
        }
    },
    getters:{
        non_driveLicenseShow:state=>state.non_driveLicenseShow,
    },
}